import { useEffect, useState } from 'react';
import { collection, limit, onSnapshot, query, where } from 'firebase/firestore';
import { db } from '@/lib/firebase';
import { tournamentConverter } from './converters';
import type { Tournament } from './types';

export function useTournamentBySlug(slug: string | undefined): {
  tournament: Tournament | null | undefined;
  error: Error | null;
} {
  const [tournament, setTournament] = useState<Tournament | null | undefined>(undefined);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    setError(null);
    if (!slug) {
      setTournament(null);
      return;
    }
    const q = query(
      collection(db, 'tournaments'),
      where('slug', '==', slug),
      limit(1)
    ).withConverter(tournamentConverter);

    return onSnapshot(
      q,
      (snap) => {
        if (snap.empty) {
          setTournament(null);
          return;
        }
        setTournament(snap.docs[0].data());
      },
      (err) => setError(err)
    );
  }, [slug]);

  return { tournament, error };
}
